const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry); // ページの視覚的な安定性の指標
      getFID(onPerfEntry); // ページの応答性の指標
      getFCP(onPerfEntry); // ユーザが体感する読み込み開始測度
      getLCP(onPerfEntry); // ページの読み込み測度の指標
      getTTFB(onPerfEntry); // サーバの応答速度
    });
  }
};
// ユーザのリクエスト　→　（TTFB）　→　ブラウザがデータ受信＆処理　→　（FCP）　→　主要コンテンツ表示（LCP)

export default reportWebVitals;
